import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { XCircle, Loader2, MailCheck } from "lucide-react";
import MobileShell from "@/components/MobileShell";
import client from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";

export default function VerifyEmail() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token");
  const { refresh } = useAuth();
  const { t } = useLang();
  const [status, setStatus] = useState("checking");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) { setStatus("error"); return; }
    client.post("/auth/verify-email", { token })
      .then(async () => { setStatus("ok"); if (localStorage.getItem("melletic_token")) await refresh(); })
      .catch(() => setStatus("error"));
  }, [token, refresh]);

  return (
    <MobileShell nav={false}>
      <div className="min-h-screen flex flex-col items-center justify-center text-center px-8">
        {status === "checking" && (
          <div data-testid="verify-checking">
            <Loader2 className="animate-spin text-violet-400 mx-auto" size={44} />
            <h1 className="font-heading text-xl font-extrabold text-white mt-5">{t("verify_checking")}</h1>
          </div>
        )}
        {status === "ok" && (
          <div data-testid="verify-success" className="animate-float-up">
            <span className="w-20 h-20 rounded-full mel-gradient flex items-center justify-center text-white mx-auto shadow-[0_16px_40px_-10px_rgba(37,99,235,0.9)]"><MailCheck size={38} /></span>
            <h1 className="font-heading text-2xl font-extrabold text-white mt-5">{t("verify_ok_title")}</h1>
            <p className="text-slate-300 mt-2">{t("verify_ok_sub")}</p>
            <button onClick={() => nav("/home")} data-testid="verify-home-btn" className="mt-6 w-full mel-gradient text-white font-bold py-3.5 rounded-2xl press">{t("continue_word")}</button>
          </div>
        )}
        {status === "error" && (
          <div data-testid="verify-error">
            <XCircle className="text-red-400 mx-auto" size={44} />
            <h1 className="font-heading text-xl font-extrabold text-white mt-5">{t("verify_err_title")}</h1>
            <p className="text-slate-400 text-sm mt-1">{t("verify_err_sub")}</p>
            <button onClick={() => nav("/home")} className="mt-6 w-full glass text-white font-semibold py-3.5 rounded-2xl press" data-testid="verify-home-btn2">{t("back_home")}</button>
          </div>
        )}
      </div>
    </MobileShell>
  );
}
